/**
 * Freight methods as quotes are priced (SKU master) and how a PO's container
 * type maps onto them. One place for the mapping so PO pre-fill, the
 * save-prices prompt, and the SKU master agree.
 */

export type FreightMethod = "40hc" | "40gp" | "20dc" | "lcl" | "fob";

export const METHOD_LABELS: Record<FreightMethod, string> = {
  "40hc": "DDP 40'HQ",
  "40gp": "DDP 40'GP",
  "20dc": "DDP 20'DC",
  lcl: "LCL",
  fob: "FOB",
};

// PO container types (poConstants: LCL / 20FT / 40FT / 40HC) → quote method.
// "40HC" is the stored value; the team says "40' HQ", so it is shown as that.
export const CONTAINER_LABELS: Record<string, string> = {
  LCL: "LCL",
  "20FT": "20' DC",
  "40FT": "40' GP",
  "40HC": "40' HQ",
};
export const containerLabel = (containerType?: string | null): string =>
  containerType ? CONTAINER_LABELS[containerType.toUpperCase()] ?? containerType : "";

export const CONTAINER_TO_METHOD: Record<string, FreightMethod> = {
  "40HC": "40hc",
  "40FT": "40gp",
  "20FT": "20dc",
  LCL: "lcl",
};

// When the PO's container has no quote, fall back through these, FOB last
export const METHOD_PREFERENCE: FreightMethod[] = ["40hc", "40gp", "20dc", "lcl", "fob"];

export const methodForContainer = (containerType?: string | null): FreightMethod | undefined =>
  containerType ? CONTAINER_TO_METHOD[containerType.toUpperCase()] : undefined;

/** The SKU master price to suggest for a PO line, given the PO's container type. */
export function catalogPriceFor(
  prices: Partial<Record<FreightMethod, number>> | undefined,
  containerType?: string | null,
): number | undefined {
  if (!prices) return undefined;
  const preferred = methodForContainer(containerType);
  if (preferred && prices[preferred] != null) return prices[preferred];
  for (const method of METHOD_PREFERENCE) {
    if (prices[method] != null) return prices[method];
  }
  return undefined;
}
